export const featureName = 'auth';